import { gql } from '@apollo/client';

const TICKET_COMMENTS_FRAGMENT = gql`
  fragment TicketCommentsFragment on TicketComment {
    id
    createdBy {
      id
      firstName
      lastName
    }
    createdAt
    content
    action
  }
`;

export default TICKET_COMMENTS_FRAGMENT;
